import { CanActivateFn } from '@angular/router';
import {inject} from '@angular/core';
import {RedirectHandlerService} from '../../services/test/redirect-handler.service';

export const customersMsalGuard: CanActivateFn = (route, state) => {
  const redirectHandlerService = inject(RedirectHandlerService);

  console.log(redirectHandlerService.activeAccount);

  return !!redirectHandlerService.activeAccount;
};
